import useCategories from '@/hooks/use-categories';
import { getTextColorForBackground } from '@polybank/shared';
import { useMemo } from 'react';

const useCategoryColor = (categoryId?: string) => {
  const { categoriesMap } = useCategories();
  const category = categoryId ? categoriesMap[categoryId] : undefined;

  const textColor = useMemo(() => {
    return getTextColorForBackground(category?.color ?? '');
  }, [category?.color]);

  return category?.color
    ? { bg: category.color, text: textColor }
    : { bg: '#F1F5F9', text: '#334155' };
};
export default useCategoryColor;
